import React from "react";
import { useOutlet } from "react-router";
import { MatterTemplateDataImportContainer } from "./matter-template-data-import-container";

export const MatterTemplateDataImport = () => {
  const outlet = useOutlet();
  return outlet || <MatterTemplateDataImportContainer />;
};
